// src/pages/DashboardPage.tsx
import React from 'react';
import { useCompany } from '../components/CompanySelector';

const DashboardPage: React.FC = () => {
  const { selectedCompany } = useCompany();

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">Welcome to Your Financial Report App!</h2>
      <p className="text-gray-600 mb-6">
        Select a company and navigate through the sidebar to generate various financial reports.
      </p>

      {selectedCompany ? (
        <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-700 p-4 rounded-md" role="alert">
          <p className="font-bold">Current Company Selected:</p>
          <p className="text-lg">{selectedCompany.name}</p>
        </div>
      ) : (
        <div className="bg-yellow-50 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded-md" role="alert">
          <p className="font-bold">No Company Selected</p>
          <p>Please select a company from the dropdown in the header to view reports.</p>
        </div>
      )}

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-xl font-semibold mb-2">General Ledger</h3>
          <p className="text-gray-600">Detailed transactions for each account.</p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-xl font-semibold mb-2">Balance Sheet</h3>
          <p className="text-gray-600">Financial position at a specific point in time.</p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-xl font-semibold mb-2">Profit & Loss</h3>
          <p className="text-gray-600">Financial performance over a period.</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;